export enum PaymentSubmissionModalType {
  PaymentCategory,
  PaymentSubcategory,
  AddExpense,
}
